import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';
import format from 'string-template';
import { connect } from 'react-redux';
import { length, required } from 'redux-form-validators';

import {
    NAME_LENGTH,
    FIRSTNAME_LENGTH,
    CITY_LENGTH,
    ZIP_CODE_LENGTH,
    ADDRESS_LENGTH
} from '../../../../constants/form';
import { API_ROOT, APPLICATION_ID } from '../../../../constants';
import { HTTP_METHOD_POST } from '../../../../constants/httpMethod';

import {
    LegendFieldComponent,
    TextInputFieldComponent,
    NumberInputFieldComponent
} from '../../../../components/form';

import { BillFormContainer } from './DownloadBillFormComponentStyle.js';

const DownloadBillFormComponent = ({
    orderId,
    email,
    hmac,
    i18n,
    i18nFeatureForm,
    i18nErrorMessage
}) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const submit = formData => {
        setLoading(true);
        setError(null);

        const url =
            APPLICATION_ID === '111' && !email
                ? `${API_ROOT}/public/ebon/order/${orderId}/cofidis/bill`
                : `${API_ROOT}/public/ebon/order/${orderId}/bill`;
        const config = {
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json;charset=UTF-8' },
            method: HTTP_METHOD_POST,
            body: JSON.stringify(formData)
        };
        fetch(url, config).then(function(response) {
            if (response.ok) {
                response.blob().then(blob => {
                    var file = new Blob([blob], { type: 'application/pdf' });
                    saveAs(file, 'Facture');
                });
                setLoading(false);
            } else {
                setError(i18nErrorMessage.UNKNOWN_ERROR);
                setLoading(false);
            }
        });
    };

    return (
        <BillFormContainer
            form="ebonbilldownload-form"
            classNameInputContainer="grid-2 has-gutter"
            requestSubmit={loading}
            onSubmit={submit}
            submitText={i18n.BILL.BUTTON}
            initialValues={{ email: email, hmac: hmac }}>
            <TextInputFieldComponent
                name="lastname"
                label={i18nFeatureForm.LABEL_LASTNAME}
                placeholder={i18nFeatureForm.PLACEHOLDER_LASTNAME}
                isRequired
                classNameInputContainer="one-half"
                validate={[
                    required({ msg: i18nFeatureForm.REQUIRED }),
                    length({
                        max: NAME_LENGTH,
                        msg: format(i18nFeatureForm.LASTNAME_SIZE_ERROR, NAME_LENGTH)
                    })
                ]}
            />
            <TextInputFieldComponent
                name="firstname"
                label={i18nFeatureForm.LABEL_FIRSTNAME}
                placeholder={i18nFeatureForm.PLACEHOLDER_FIRSTNAME}
                isRequired
                classNameInputContainer="one-half"
                validate={[
                    required({ msg: i18nFeatureForm.REQUIRED }),
                    length({
                        max: FIRSTNAME_LENGTH,
                        msg: format(i18nFeatureForm.FIRSTNAME_SIZE_ERROR, FIRSTNAME_LENGTH)
                    })
                ]}
            />
            <TextInputFieldComponent
                name="address"
                label={i18nFeatureForm.LABEL_ADDRESS}
                placeholder={i18nFeatureForm.LABEL_ADDRESS}
                isRequired
                classNameInputContainer="full"
                validate={[
                    required({ msg: i18nFeatureForm.REQUIRED }),
                    length({
                        max: ADDRESS_LENGTH,
                        msg: format(i18nFeatureForm.ADDRESS_SIZE_ERROR, ADDRESS_LENGTH)
                    })
                ]}
            />
            <TextInputFieldComponent
                name="city"
                label={i18nFeatureForm.LABEL_CITY}
                placeholder={i18nFeatureForm.LABEL_CITY}
                isRequired
                classNameInputContainer="one-half"
                validate={[
                    required({ msg: i18nFeatureForm.REQUIRED }),
                    length({
                        max: CITY_LENGTH,
                        msg: format(i18nFeatureForm.CITY_SIZE_ERROR, CITY_LENGTH)
                    })
                ]}
            />
            <NumberInputFieldComponent
                name="postCode"
                label={i18nFeatureForm.LABEL_ZIPCODE}
                placeholder={i18nFeatureForm.LABEL_ZIPCODE}
                isRequired
                classNameInputContainer="one-half"
                validate={[
                    required({ msg: i18nFeatureForm.REQUIRED }),
                    length({
                        max: ZIP_CODE_LENGTH,
                        msg: format(i18nFeatureForm.ZIP_CODE_SIZE_ERROR, ZIP_CODE_LENGTH)
                    })
                ]}
            />

            <LegendFieldComponent classNameInputContainer="full">
                {i18nFeatureForm.MANDATORY_FIELD}
            </LegendFieldComponent>

            {error && (
                <LegendFieldComponent classNameInputContainer="color-err">
                    {error}
                </LegendFieldComponent>
            )}
        </BillFormContainer>
    );
};

DownloadBillFormComponent.propTypes = {
    orderId: PropTypes.string.isRequired,
    email: PropTypes.string,
    hmac: PropTypes.string.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.EBON,
        i18nFeatureForm: state.i18n.feature.form,
        i18nErrorMessage: state.i18n.HTTP_STATUS_CODE_MESSAGE
    };
}

export default connect(mapStateToProps)(DownloadBillFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/download/DownloadBillFormComponent.js